import { createContext } from 'react';
import { BadgeV2Props } from './badge-v2.types';

export const BadgeV2Context = createContext<Pick<BadgeV2Props, 'size'>>({ size: 'medium' });
